import { LocalStorageCache } from '@auth0/auth0-spa-js';

/**
 * Get locally stored access token from Auth0's localStorage cache
 */
export const getLocallyStoredAccessToken = (type = 'accessToken') => {
  const localStorageCache = new LocalStorageCache();
  const key: string =
    localStorageCache
      ?.allKeys()
      ?.find((eachKey) =>
        eachKey?.includes(process.env.REACT_APP_AUTH0_AUDIENCE as string),
      ) || '';
  const auth0AccessTokenStruct: any = localStorageCache?.get(key) || {};
  switch (type) {
    case 'accessToken':
      return auth0AccessTokenStruct?.body?.access_token || '';
    case 'expiresAt':
      return auth0AccessTokenStruct?.expiresAt || -1;
    default:
      return null;
  }
};

export const getLocallyStoredIdToken = () => {
  const localStorageCache = new LocalStorageCache();
  const idTokenKeySuffix = `${process.env.REACT_APP_AUTH0_CLIENT_ID}::@@user@@`;
  const key: string =
    localStorageCache
      ?.allKeys()
      ?.find((eachKey) => eachKey?.includes(idTokenKeySuffix)) || '';
  const idTokenStruct: any = localStorageCache?.get(key) || {};
  return idTokenStruct?.id_token || '';
};
